const tabSwitchers = document.querySelectorAll(".tab-switcher");
const windowWidth = window.innerWidth;

export const SetActiveDropDownHeaderMobile = () => {
    if (windowWidth <= 768) {
        tabSwitchers.forEach((item) => {
            const text = getActiveTabText(item);
            m_setActiveDropdownHeading(item, text);
        });
    }
};

export const TabSwitcherClickHandlers = () => {
    if (windowWidth <= 768) {
        tabSwitchers.forEach((item) => {
            m_dropDownToggle(item);
        });
    }

    tabSwitchers.forEach((item) => {
        const buttons = item.querySelectorAll(".tab-switcher__button");
        buttons.forEach((button, idx) => {
            button.addEventListener("click", function () {
                removeActiveClassOnButtonClick(this);
                addActiveClassOnButtonClick(this);
                removeActiveClassOnSection(item);
                setActiveClassOnSection(item, idx);

                if (windowWidth <= 768) {
                    const text = getActiveTabText(item);
                    m_setActiveDropdownHeading(item, text);
                    slideUpContainer(item);
                }
            });
        });
    });
};

const getActiveTabText = (item) => {
    let activeHeading = item.querySelector(
        ".tab-switcher__button--active"
    ).textContent;

    return activeHeading;
};

const m_setActiveDropdownHeading = (item, text) => {
    const dropDownHeader = item.querySelector(".tab-switcher__active-heading");
    dropDownHeader.textContent = text;
};

const m_dropDownToggle = (item) => {
    const heading = item.querySelector(".tab-switcher__active-heading");
    heading.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
};

const addActiveClassOnButtonClick = (button) => {
    button.classList.add("tab-switcher__button--active");
};

const removeActiveClassOnButtonClick = (item) => {
    const button = item.parentElement.querySelector(
        ".tab-switcher__button--active"
    );
    button.classList.remove("tab-switcher__button--active");
};

const slideUpContainer = (item) => {
    const activeHeading = item.querySelector(".tab-switcher__button-section");
    activeHeading.classList.remove("active");
};

const setActiveClassOnSection = (item, idx) => {
    const sections = item.querySelectorAll(".tab-switcher__info-container");
    sections[idx].classList.add("tab-switcher__info-container--active");
};

const removeActiveClassOnSection = (item) => {
    const sections = item.querySelectorAll(".tab-switcher__info-container");
    sections.forEach((section) => {
        section.classList.remove("tab-switcher__info-container--active");
    });
};
